'use client';

export const Search = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M12.0719 22.0657C9.2593 22.0657 6.87749 21.0905 4.92649 19.14C2.9755 17.1896 2 14.8204 2 12.0326C2 9.2451 2.97522 6.87611 4.92567 4.92567C6.87611 2.97522 9.24717 2 12.0388 2C14.8305 2 17.2013 2.97522 19.1512 4.92567C21.1013 6.87611 22.0764 9.24524 22.0764 12.033C22.0764 13.1993 21.8781 14.3276 21.4813 15.4178C21.0848 16.508 20.5261 17.4825 19.805 18.3414L29.6925 28.1846C29.8919 28.376 29.9943 28.6226 29.9998 28.9245C30.005 29.2267 29.9026 29.481 29.6925 29.6876C29.4827 29.8938 29.2293 29.9969 28.9324 29.9969C28.6357 29.9969 28.3864 29.892 28.1846 29.6822L18.3244 19.822C17.5 20.535 16.5433 21.0873 15.4542 21.4788C14.3648 21.8701 13.2374 22.0657 12.0719 22.0657ZM12.055 19.9874C14.272 19.9874 16.1501 19.216 17.6892 17.673C19.2282 16.1298 19.9978 14.2497 19.9978 12.0326C19.9978 9.81557 19.2282 7.93557 17.6892 6.39264C16.1501 4.84971 14.272 4.07824 12.055 4.07824C9.82853 4.07824 7.94246 4.84971 6.39677 6.39264C4.85109 7.93557 4.07824 9.81557 4.07824 12.0326C4.07824 14.2497 4.85109 16.1298 6.39677 17.673C7.94246 19.216 9.82853 19.9874 12.055 19.9874Z"
				fill="currentColor"
			/>
		</svg>
	);
};
